module.exports = __webpack_public_path__ + "static/media/field-red.df23cb5b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/field-red.svg
// module id = 43
// module chunks = 0